import {Grid, Typography} from "@mui/material";
import {UseFormReturn} from "react-hook-form";
import {ControlledDatePicker, ControlledTextField} from "src/components/forms";
import CardActions from "src/pages/sistema/components/CardActions";
import {FormOperacionCorporateLending} from "../types/types";
import {OperacionCorporateLendingFields} from "../types/fields";
import {dateFormatter} from "src/utils/formatters";
import {OperacionCorporateLendingViewDTO} from "../types/dto";

type DatosOperacionProps = {
  formMethods: UseFormReturn<FormOperacionCorporateLending>
  readOnly?: boolean
  operacion?: OperacionCorporateLendingViewDTO
  codSistemaPrincipal: number
  nuevo?: boolean
}

const SeccionCorporateLendingDatosOperacion = ({
                                                 formMethods,
                                                 readOnly,
                                                 operacion,
                                                 codSistemaPrincipal,
                                                 nuevo
                                               }: DatosOperacionProps) => {

  const {control, watch} = formMethods

  return (
      <Grid container spacing={4}>
        {
          !nuevo &&
            <Grid item xs={12} md={3}>
                <Typography variant='body2'>Usuario Alta</Typography>
                <Typography>{operacion && `${operacion.nombreUsuarioAlta} ${operacion.apellidoUsuarioAlta}`}</Typography>
            </Grid>
        }

        {
          readOnly ? (
            <Grid item xs={12} md={3}>
              <Typography variant='body2'>Fecha Emisión</Typography>
              <Typography>{operacion ? dateFormatter.toShortDate(operacion?.[OperacionCorporateLendingFields.FechaAlta]) : '-'}</Typography>
            </Grid>
          ) : <></>
        }

        <Grid item xs={12} md={3}>
          {
            readOnly ? (
              <>
                <Typography variant='body2'>Fecha Vencimiento</Typography>
                <Typography>{(operacion && operacion?.fechaVencimiento) ? dateFormatter.toShortDate(operacion?.fechaVencimiento) : '-'}</Typography>

              </>
            ) : (
              <ControlledDatePicker
                name={OperacionCorporateLendingFields.FechaVencimiento}
                label='Fecha Vencimiento'
                control={control}
                selectedSections={undefined}
                onSelectedSectionsChange={console.log}
                fullWidth
                readOnly={readOnly}
              />
            )
          }
        </Grid>
        <Grid item xs={12}>
          {readOnly ?
            <>
              <Typography variant='body2'>Observaciones</Typography>
              <Typography>{operacion?.observaciones || '-'}</Typography>
            </> :
            <ControlledTextField
              name={OperacionCorporateLendingFields.Observaciones}
              label='Observaciones'
              control={control}
              fullWidth
              multiline
              rows={2}
            />}
        </Grid>

      </Grid>
  )
}

export default SeccionCorporateLendingDatosOperacion;